// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Real token/chain logos (CryptoLogo.jsx). Plain classes so they work on every
   page regardless of the .ent enterprise scope. */

.crypto-logo {
  display: inline-block;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #fff;
}

.crypto-logo--glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
}

.crypto-logo-stack {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

/* Chain badge sits in the corner with a ring matching the surface behind it. */
.crypto-logo-stack__chain {
  position: absolute;
  right: -2px;
  bottom: -2px;
  display: inline-flex;
  border-radius: 50%;
  overflow: hidden;
  background: var(--bg-primary, #fff);
  box-shadow: 0 0 0 1.5px var(--bg-primary, #fff);
}

.crypto-logo-stack__chain .crypto-logo {
  background: var(--bg-primary, #fff);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CryptoLogo.css"],"names":[],"mappings":"AAAA;kDACkD;;AAElD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* Real token/chain logos (CryptoLogo.jsx). Plain classes so they work on every\n   page regardless of the .ent enterprise scope. */\n\n.crypto-logo {\n  display: inline-block;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.crypto-logo--glyph {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 1;\n}\n\n.crypto-logo-stack {\n  position: relative;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* Chain badge sits in the corner with a ring matching the surface behind it. */\n.crypto-logo-stack__chain {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  display: inline-flex;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--bg-primary, #fff);\n  box-shadow: 0 0 0 1.5px var(--bg-primary, #fff);\n}\n\n.crypto-logo-stack__chain .crypto-logo {\n  background: var(--bg-primary, #fff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
